import { crearClienteApi, type ClienteApi } from '../api/cliente';
import { operacionesClienteFinal, type OperacionesClienteFinal } from '../api/ops/clienteFinal';
import type { AlmacenCliente } from './almacenCliente';

/**
 * Cliente de la API de las páginas del cliente: el mismo `crearClienteApi` del panel (solo rutas `/v1/`, `Problem` como
 * `ErrorApi`), pero con **otra credencial**: el token de cliente de `almacenCliente`, sin renovación (dura 30 minutos y,
 * al caducar, se vuelve a pedir un código). La sesión del equipo no está a su alcance.
 */
export type CrearApi = (obtenerToken: () => string | null) => ClienteApi;

export const crearApiPorDefecto: CrearApi = (obtenerToken) => crearClienteApi({ base: '', obtenerToken });

export function operacionesDeLaZona(crear: CrearApi, almacen: AlmacenCliente, clavePublica: string | null): OperacionesClienteFinal {
    return operacionesClienteFinal(crear(() => almacen.actual()?.token ?? null), clavePublica);
}

/** Clave pública provisional de las páginas de Reservaria (sin negocio); sin ella no se manda y la API responde 401. */
export function clavePublicaDelEntorno(env: Record<string, string | boolean | undefined> = import.meta.env): string | null {
    const v = env.VITE_CLAVE_PUBLICA_CLIENTES;
    return typeof v === 'string' && v !== '' ? v : null;
}
